var _path, _path2, _g, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCardRecurringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_1688)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_1688",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -5,
    y: -5,
    width: 30,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 -5H-5V20H25V-5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 11.6C15.1673 11.6 16.6 10.1673 16.6 8.39995C16.6 6.63264 15.1673 5.19995 13.4 5.19995C11.6327 5.19995 10.2 6.63264 10.2 8.39995C10.2 10.1673 11.6327 11.6 13.4 11.6Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_1688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.713 8.388C13.713 8.73987 13.5736 9.07741 13.3252 9.32669C13.0769 9.57597 12.7399 9.71668 12.388 9.718H1.325C0.973048 9.71694 0.635887 9.57632 0.387487 9.32698C0.139087 9.07764 -0.000265659 8.73995 3.80222e-07 8.388V1.328C3.80222e-07 0.596001 0.593 0.001 1.325 0H12.387C12.7388 0.000793988 13.0759 0.141027 13.3245 0.38996C13.573 0.638894 13.7127 0.97622 13.713 1.328V5.518C13.7138 5.56938 13.6943 5.619 13.6587 5.65608C13.6231 5.69315 13.5744 5.71469 13.523 5.716C13.444 5.73182 13.362 5.72048 13.2903 5.68381C13.2186 5.64714 13.1614 5.58729 13.128 5.514V4.444H0.584V8.388C0.584 8.798 0.916 9.13 1.325 9.131H12.387C12.5837 9.13047 12.7722 9.05196 12.9111 8.91267C13.05 8.77339 13.128 8.58471 13.128 8.388V8.122C13.2118 8.03144 13.324 7.97217 13.446 7.954C13.728 7.949 13.713 8.388 13.713 8.388ZM0.584 3.858H13.128V2.758H0.584V3.858ZM0.584 2.172H13.128V1.328C13.1277 1.13164 13.0498 0.943361 12.9111 0.804323C12.7724 0.665286 12.5844 0.586793 12.388 0.586H1.324C1.12764 0.586793 0.939574 0.665286 0.800911 0.804323C0.662248 0.943361 0.584263 1.13164 0.584 1.328V2.172ZM5.793 8.128H4.34C4.26216 8.128 4.18751 8.09708 4.13246 8.04204C4.07742 7.98699 4.0465 7.91234 4.0465 7.8345C4.0465 7.75666 4.07742 7.68201 4.13246 7.62696C4.18751 7.57192 4.26216 7.541 4.34 7.541H5.793C5.87084 7.541 5.94549 7.57192 6.00054 7.62696C6.05558 7.68201 6.0865 7.75666 6.0865 7.8345C6.0865 7.91234 6.05558 7.98699 6.00054 8.04204C5.94549 8.09708 5.87084 8.128 5.793 8.128ZM2.919 8.128H1.75C1.67216 8.128 1.59751 8.09708 1.54246 8.04204C1.48742 7.98699 1.4565 7.91234 1.4565 7.8345C1.4565 7.75666 1.48742 7.68201 1.54246 7.62696C1.59751 7.57192 1.67216 7.541 1.75 7.541H2.918C2.99584 7.541 3.07049 7.57192 3.12554 7.62696C3.18058 7.68201 3.2115 7.75666 3.2115 7.8345C3.2115 7.91234 3.18058 7.98699 3.12554 8.04204C3.07049 8.09708 2.99684 8.128 2.919 8.128Z",
    fill: "#0077BD"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3532 5.60852L14.8707 6.86129L13.6724 6.97022",
    stroke: "#43A03B",
    strokeWidth: 0.748936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5474 6.90298C14.2304 6.58792 13.8215 6.38164 13.3797 6.31386C12.938 6.24606 12.486 6.32026 12.0891 6.52575C11.6923 6.73124 11.3708 7.05743 11.1712 7.4573C10.9716 7.85718 10.904 8.31011 10.9784 8.75084C11.0526 9.19157 11.2649 9.59734 11.5846 9.9097C11.9042 10.2221 12.3147 10.4249 12.7572 10.4889C13.1994 10.553 13.6507 10.4749 14.0459 10.2661C14.441 10.0573 14.7597 9.72836 14.9559 9.32681",
    stroke: "#43A03B",
    strokeWidth: 0.748936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_1688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 12,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardRecurringIcon);
export default __webpack_public_path__ + "static/media/card_recurring_icon.b986f113f90f59c7d6d8e0474b83a674.svg";
export { ForwardRef as ReactComponent };